<div
  class="flex flex-column sm:flex-column md:flex md:flex-wrap lg:flex-wrap xl:flex-wrap md:flex-none md:flex-row lg:flex-row xl:flex-row">
  @if (cookieRole === 'SYSADMIN') {
    <mat-form-field
      class="col-11 sm:col-8 md:col-3 lg:col-3 xl:col-2"
      appearance="outline">
      <mat-label>Empresa</mat-label>
      <mat-select [(ngModel)]="businessId" [(value)]="selectValueCompani">
        <mat-option [value]="-1" (click)="ObtenerEdificios(-1)">
          Generales
        </mat-option>
        @for (buss of bussines; track buss) {
          <mat-option
            [value]="buss.idBusiness"
            (click)="ObtenerEdificios(buss.idBusiness!)">
            {{ buss.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <mat-form-field
    class="col-11 sm:col-8 md:col-3 lg:col-3 xl:col-2"
    appearance="outline">
    <mat-label>Edificio</mat-label>
    <mat-select [(ngModel)]="buildingId">
      @for (edificio of edificios; track edificio) {
        <mat-option
          [value]="edificio.buildingid"
          (click)="chargueFloorByBuilding(edificio.buildingid)">
          {{ edificio.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="col-11 sm:col-12 md:col-3 lg:col-3 xl:col-2"
    appearance="outline">
    <mat-label>Nivel</mat-label>
    <mat-select [(ngModel)]="floorId" [(value)]="valueNivel">
      @for (floor of floors; track floor) {
        <mat-option
          [value]="floor.floorid"
          (click)="selectFloor(floor.floorid)">
          {{ floor.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="col-11 sm:col-12 md:col-3 lg:col-3 xl:col-2"
    appearance="outline">
    <mat-label>Tipo de puesto</mat-label>
    <mat-select [(ngModel)]="workPlaceId">
      @for (puesto of puestos; track puesto) {
        <mat-option
          [value]="puesto.workplacetypeid"
          (click)="selectType(puesto.workplacetypeid)">
          {{ puesto.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="col-11 sm:col-12 md:col-3 lg:col-3 xl:col-2"
    appearance="outline">
    <mat-label>Rango de fechas</mat-label>
    <mat-select [(ngModel)]="filter">
      @for (range of rangeFilter(); track range) {
        <mat-option [value]="range.value" (click)="getReservationsGraphic()">
          {{ range.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div
  class="flex flex-column lg:flex lg:align-content-center lg:gap-8 xl:flex xl:align-content-center xl:gap-8 md:flex-row">
  <!-- TABLA -->
  <div class="w-10 ms:w-10 md:w-10 lg:w-8 xl:w-8">
    <div class="shadow-2 overflow-auto">
      <table mat-table [dataSource]="dataSource">
        <!-- Date Column -->
        <ng-container matColumnDef="building" sticky>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Edificio</th>
          <td mat-cell *matCellDef="let element">
            {{ element.edificio }}
          </td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="floor" sticky>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nivel</th>
          <td mat-cell *matCellDef="let element">{{ element.nivel }}</td>
        </ng-container>
        <!-- User Column -->
        <ng-container matColumnDef="workplace">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Puestos de trabajo
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.puesto }}
          </td>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="frequency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Frecuencia</th>
          <td mat-cell *matCellDef="let element">
            {{ element.frecuencia }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <br />
    <!-- paginador -->
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>
  <!-- BOTONES -->
  <div class="flex ml-8 pl-4 py-6 justify-content-center flex-column gap-2">
    <shared-button
      [icon]="'save_alt'"
      [typeBtn]="'button'"
      (click)="downloadExcel()"
      color="accent">
      Excel
    </shared-button>
    <shared-button
      [icon]="'save_alt'"
      [typeBtn]="'button'"
      (click)="downloadPDF()"
      color="accent">
      P D F
    </shared-button>
  </div>
</div>

<!-- Grafica de calor -->
<div id="graficaCalor" class="flex justify-content-center">
  <div
    [style]="chargeSizeImage()"
    id="heatmapContainer"
    role="button"
    tabindex="0">
    @if (imgSource() !== '') {
      <img
        [src]="imgSource()"
        alt="map color"
        class="background-image"
        [style]="chargeSizeImage()" />
    }
    <!-- <div class="overlay"></div> -->
  </div>

  <div *ngIf="selectedCoordinates.length" class="table-container">
    <table class="table">
      <thead>
        <tr>
          <th>#</th>
          <th>x</th>
          <th>y</th>
          <th>value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let coord of selectedCoordinates; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ coord.x }}</td>
          <td>{{ coord.y }}</td>
          <td>{{ coord.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
